export default {
  CUSTOMER_BANK_ACCOUNT_STATE_MANAGER: Symbol.for('CUSTOMER_BANK_ACCOUNT_STATE_MANAGER'),
  CUSTOMER_BANK_ACCOUNT_REPOSITORY: Symbol.for('CUSTOMER_BANK_ACCOUNT_REPOSITORY'),
  UPDATE_CUSTOMER_BANK_ACCOUNT_COMMAND: Symbol.for('UPDATE_CUSTOMER_BANK_ACCOUNT_COMMAND'),
  CUSTOMER_BANK_ACCOUNT_CHOOSE_YOUR_DOCUMENTS_SERVICE: Symbol.for('CUSTOMER_BANK_ACCOUNT_CHOOSE_YOUR_DOCUMENTS_SERVICE'),
};
